module.exports = __webpack_public_path__ + "static/img/t-2-a.0db75729.png";